import React, { useEffect, useState, useCallback } from 'react';
import "./funds.css";
import "../../common/css/layout.css";
import { useForm } from 'react-hook-form';
import FundsForm from "./FundsForm";
import FundsTable from "./FundsTable";
import FundsChart from "../dashboard/FundsChart";
import { fetchFunds } from '../../common/helpers/FundsHelper';

const Funds = () => {
  const {
    register,
    formState: { errors },
  } = useForm();
  const [data, setData] = useState(null);
  const [editData, setEditData] = useState(null);

  const fetch = useCallback(async () => {
    const fetchedData = await fetchFunds();
    setData(fetchedData);
  }, []);
  
  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleEdit = (fund) => {
    setEditData({
        fundId: fund.internal_fund_id,
        fundName: fund.fund_name,
        targetAssets: fund.target_aum,
        currentAssets: fund.current_aum,
        fundLPPortal: fund.fund_lp_portal
    });
};

const handleClear = () => {
  setEditData(null);
};

  const handleSubmit = () => {
    setEditData(null); // Clear the form after submitting
    fetch(); // Refetch the data to update the table and chart
  };

  return (
    <div className="all-components-container">
    <div className="component component-in-row-2">
        <div className="component-heading">
            Manage Funds
        </div>
        <FundsForm onSubmit={handleSubmit} editData={editData} onClear={handleClear} />
    </div>
    <div className="component-no-border component-in-row-2">
        <div className="component-heading">
            <h2>Funds by Target AUM</h2>
        </div>
        {data && <FundsChart data={data} />}
    </div>
    <div className="component-no-border component-in-row-1">
        {data && <FundsTable data={data} onEdit={handleEdit} onDelete={fetch} />}
    </div>
</div>

  )
}

export default Funds;
